import { Sheet } from '../Sheet';
import { LeagueSwitcherList } from './LeagueSwitcherList';
import { useOrderedMemberships } from './helpers';
import type { LeagueSwitcherMenuProps } from './types';

/** Mobile bottom sheet — full-screen scrim, slides up from the bottom. */
export function LeagueSwitcherSheet({
  open,
  activeId,
  memberships,
  leagues,
  unreadByLeague,
  onClose,
  onSelect,
  onAll
}: LeagueSwitcherMenuProps & { open: boolean }) {
  const ordered = useOrderedMemberships(memberships);

  return (
    <Sheet open={open} onClose={onClose} ariaLabel="Your leagues" mobileOnly className="flex max-h-[80vh] flex-col">
      <div className="flex items-end justify-between gap-3 px-5 pb-2 pt-1">
        <div>
          <h2 className="text-[19px] font-extrabold tracking-[-0.02em] text-ink">Your leagues</h2>
          <p className="mt-0.5 text-[12px] font-semibold text-ink2">Each league is its own world</p>
        </div>
        <span className="rounded-full bg-fill px-2.5 py-1 text-[11px] font-bold tabular-nums text-ink2">
          {ordered.length}
        </span>
      </div>
      <div className="native-scroll no-scrollbar flex-1 space-y-1 overflow-y-auto px-3 pb-3 pt-1">
        <LeagueSwitcherList
          activeId={activeId}
          memberships={memberships}
          leagues={leagues}
          unreadByLeague={unreadByLeague}
          onSelect={onSelect}
          onAll={onAll}
        />
      </div>
    </Sheet>
  );
}
